
import { appointmentsModule } from '@/store/modules/store-accessor'
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';

@Component
export default class EventOverlappingWarning extends Vue {
  @Prop({ default: 'appointment' }) eventType!: 'appointment' | 'task';

  get overlappingEvents() {
    return appointmentsModule.overlappingEvents;
  }

  get showOverlappingMsg() {
    return appointmentsModule.overlappingEvents?.length > 0;
  }

  get eventTitle() {
    const type = this.eventType === 'task' ? 'taskLowerCase' : 'appointmentLowerCase';
    return this.$t('overlappingEventsAlertTitle', { type: this.$t(type) });
  }

}
